// const backendUtilityUrl = 'http://10.68.184.82:1234/'
// const backendBookartUrl='https://bookart.elsevier.com/api/'
// const FaqVideoDev  = "https://d8z20visq58cz.cloudfront.net/Elsevier_chennai.mp4"
// const FaqVideoUat = "https://de0t3wuu3omo4.cloudfront.net/Elsevier_chennai.mp4"
// const FaqVideoUrl = FaqVideoDev
// export {backendBookartUrl, FaqVideoUrl }
const backendBookartUrl = 'https://bookart.elsevier.com/api/'
const FaqVideoDev = "https://d8z20visq58cz.cloudfront.net/Elsevier_chennai.mp4"
const allbooksFinalVideo = "https://d2j1sql5sv2ueu.cloudfront.net/All+Books+-+Final.mp4"
const instantOrderVideo = "https://d2j1sql5sv2ueu.cloudfront.net/Instant+order+-+Final.mp4"
const orderHistoryVideo = "https://d2j1sql5sv2ueu.cloudfront.net/Order+History+-+Final.mp4"
const supportPageVideo = "https://d2j1sql5sv2ueu.cloudfront.net/Support+page+-+Final.mp4"
export {backendBookartUrl, allbooksFinalVideo, instantOrderVideo, orderHistoryVideo, supportPageVideo }
